import { useEffect, useState } from "react";
import { Carousel } from "react-bootstrap";
import { isMobile } from "react-device-detect";

// Components
import Section from "../Section/SectionContainer";

// CSS
import styles from "./conferences-previous.module.scss";

// Utils
import { formatCarouselArray } from "../../utils/miscUtils";

export const ConferencesPrevious = (props) => {
    const { conferences, conference, history } = props;

    /**
     * useState
     */

    const [previousConferences, setPreviousConferences] = useState(null);

    /**
     * useEffect
     */

    useEffect(() => {
        if (conferences || conference) {
            const filteredConferences = conferences.filter(
                //(conference) => !conference.is_active && !conference.is_latest
                (conference) => !conference.is_latest
            );
            const size = isMobile ? 1 : 4;
            setPreviousConferences(
                formatCarouselArray(filteredConferences, { size })
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [conferences]);

    /**
     * End Hooks
     */

    function renderConferenceItems() {
        return previousConferences?.map((group, i) => {
            return (
                <Carousel.Item key={i}>
                    <div className={styles.items}>
                        {group
                            .filter((item) => {
                                //return !item.is_active;
                                return !item.is_latest;
                            })
                            .map((item, i, arr) => {
                                const { id, image, slug, title } = item;
                                return (
                                    <div
                                        className={styles.item}
                                        key={id}
                                        onClick={() =>
                                            history.push({
                                                pathname: `/conferences/${slug}`,
                                                state: { conference: item },
                                            })
                                        }
                                        style={{
                                            backgroundImage: `url(${image?.sizes?.medium_large})`,
                                        }}
                                    >
                                        <span>{title}</span>
                                    </div>
                                );
                            })}
                    </div>
                </Carousel.Item>
            );
        });
    }

    return (
        <Section id="recent_conferences" classes={styles["conferences-previous"]}>
            <h1>recent conferences</h1>
            <Carousel
                controls={!isMobile}
                indicators={isMobile}
                interval={null}
            >
                {renderConferenceItems()}
            </Carousel>
        </Section>
    );
};
